import { IPaymentOfferModel } from "@nf/common";
import cx from "classnames";
import { useTranslation } from "next-i18next";

import OfferBadge from "./CardComponents/OfferBadge";
import OfferPrice from "./CardComponents/OfferPrice";
import { useOfferSavingsText } from "./hooks";
import { PERIOD_LABEL } from "./const";

import CheckmarkIcon from "resources/icons/checkmark.svg";

import styles from "./OfferCard.module.scss";

export interface OfferCardProps {
  offer: IPaymentOfferModel;
  active?: boolean;
  handleSelect?: (offer: IPaymentOfferModel) => void;
}

export const OfferCard = ({ offer, active, handleSelect }: OfferCardProps) => {
  const { t } = useTranslation("translations");
  const savings = useOfferSavingsText(offer);

  const periodTranslationKey = PERIOD_LABEL[offer.Period];

  return (
    <div
      className={cx(styles.offer, styles.clickable, {
        [styles.active]: active,
      })}
      onClick={() => handleSelect?.(offer)}
    >
      <div className={styles.row}>
        {periodTranslationKey && (
          <OfferBadge variant="period">{t(periodTranslationKey)}</OfferBadge>
        )}

        {savings && <OfferBadge variant="savings">{savings}</OfferBadge>}
      </div>

      <div className={styles.row}>
        <OfferPrice
          price={offer.Price}
          period={offer.Period}
          savings={offer.SavingsPrice}
        />
        {active && <CheckmarkIcon className={styles.checkmark} />}
      </div>
    </div>
  );
};

export default OfferCard;
